<template>
  <div
    v-for="(item, index) in listItems"
    class="relative"
    :class="{ 'flex items-center cursor-pointer': showSelect }"
  >
    <div
      v-if="showSelect"
      class="relative mr-4"
      @click="toggleSelect(index)"
      role="button"
    >
      <IconCircleCheckFilled
        class="text-nami-comi-blue transition-all opacity-0 absolute inset-0"
        :class="{ 'opacity-100': selectedIndexes[index] }"
        :size="32"
      />
      <IconCircle
        :size="32"
        class="top-0 left-0 transition-all"
        :class="{ 'opacity-0': selectedIndexes[index] }"
      />
    </div>
    <slot
      name="listComponent"
      v-bind="{
        selected: selectedIndexes[index],
        toggle: () => toggleSelect(index),
        item,
      }"
    ></slot>
    <Skeleton v-if="loadInPlace" class="absolute inset-0" />
  </div>
</template>

<script setup lang="ts" generic="T">
import { IconCircle, IconCircleCheckFilled } from "@tabler/icons-vue";

const { listItems } = defineProps<{
  listItems: T[];
  showSelect?: boolean;
  loadInPlace?: boolean;
}>();

const selectedIndexes = defineModel<Record<number, boolean>>({
  required: true,
});

const toggleSelect = (index: number) => {
  selectedIndexes.value[index] = !selectedIndexes.value[index];
};
</script>
